var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2488_147298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9984 0.998306C9.19684 2.96284 8.71365 4.24787 7.82153 6.15418C8.36856 6.73412 9.0399 7.40912 10.1278 8.17187C8.95553 7.68953 8.15903 7.20521 7.55828 6.70262C6.4164 9.08481 4.62765 12.4789 0.997559 19.0017C3.85337 17.3547 6.06259 16.3394 8.1264 15.9512C8.03781 15.5704 7.98747 15.1587 7.9914 14.7292L7.99478 14.6378C8.03978 12.8097 8.99096 11.404 10.1174 11.4996C11.2438 11.5952 12.1193 13.1551 12.074 14.9832C12.0672 15.3134 12.0287 15.6422 11.959 15.965C13.9981 16.3638 16.1862 17.3769 19.0007 19.0017L17.4763 16.1819C16.731 15.6045 15.9539 14.8527 14.3685 14.0387C15.4583 14.322 16.2388 14.6485 16.8435 15.0138C12.0341 6.05884 11.6443 4.86915 9.99503 0.998306H9.9984Z",
    fill: "#1793D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2488_147298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArch);
export default __webpack_public_path__ + "static/media/ic-arch.abe669b8fbaf39082f5a3b134a9d1a7d.svg";
export { ForwardRef as ReactComponent };